export default "__VITE_ASSET__9a875a8f__"